import AsoHeader from '../../../components/Aso/Header';
import AsoValidarInfoReaproveitamento from '../../../components/Aso/Register/AsoValidarInfoReaproveitamento';

export function AsoRegistroValidarInfoReaproveitamento() {

  return (
    <div>
      <AsoHeader />
      <AsoValidarInfoReaproveitamento />
    </div>
  );
}
